import { AccountStatus, AccountType, CouponStatus } from "../utility/enums";

// Not using Assigned Order Status in current website
export const ORDERSTATUS = {
  created: ["Draft", "#C0C0C0", "Your order hasn’t been placed yet, but we’ve saved your progress"],
  new: ["New", "#FFD280" , "We've received your order! A team member will review the details and assign it to the appropriate translator shortly"],
  assigned: ["Assigned", "#CEF5FF", "The order C assigned, but the translation has not yet started, we will start translating it in the near future"],
  "in-progress": ["In Progress", "#8080FF", "Your documents are being translated. We’ll email you as soon as your order is ready for review."],
  "support-review": ["Quality Check", "#F299B3", "Our team is performing a final review to ensure everything is accurate and well-formatted before sending it to you"],
  revision: ["Revision", "#808080", "We’re working on the changes you requested. An updated version will be sent shortly"],
  "user-review": ["Awaits Approval", "#99CCF2", "Your translation is ready! You can download the files, approve them, or request revisions. If you purchased notarization or hard copies, your approval is required before we proceed"],
  completed: ["Completed", "#80C080", "Your order is complete, and you can now leave a review! If you purchased notarization or hard copies, they are now being scheduled for fulfillment"],
  cancelled: ["Cancelled", "#FF8080", "This order has been cancelled. If you were charged, a refund has been issued if applicable"],
  "on-hold": ["On Hold", "#FFFF80", "The order is in hold, we will update you soon"],
  refunded: ["refunded", "#C080C0", "The order has been refunded. You will get your payment back to the source within 3-7 days."],
  "cancel-hold": ["Cancellation Hold", "#FF8080", "The order has been put on hold, our team will review it and update you soon."],
};

export const QUOTESTATUS = {
  "in-review": ["In Review", "#FFD280", "We’re reviewing your quote request. You’ll hear from us shortly with final pricing"],
  replied: ["Ready", "#99CCF2", "Your quote is ready! You can now review the details and place your order"],
  ordered: ["Ordered", "#80C080", "This quote has been converted into an order. You can now track its progress"],
  cancelled: ["Cancelled", "#FF8080", "This quote has been cancelled. Let us know if you’d like to revisit it"],
}; 
// export const INVOICESTATUS = {
//   "Waiting Payment": ["Awaiting Payment", "#FFD9C4", "This invoice is awaiting payment. You can pay directly or share the payment link from the Invoice Page."],
//   "Paid": ["Paid", "#C1F4C3", "This invoice has been paid in full"],
  
// };

export const INVOICESTATUS = {
  paid: ["Paid", "#80C080", "The invoice is paid, you can view the invoice and download the invoice"],
  "paid-manually": ["Paid", "#80C080", "The invoice is paid, you can view the invoice and download the invoice"],
  "pay-later": ["Waiting Payment", "#FFD280", "This invoice is awaiting payment. You can pay directly or share the payment link from the Invoice Page."],
  "on-hold": ["On Hold", "#FFFF80", "The invoice is in hold, we are review it and will update you soon"],
  overdue: ["Overdue", "#FF8080", "The invoice is in overdue, please pay for the invoice or contact our support team."],
  cancelled: ["Cancelled", "#FF8080", "The invoice has been cancelled"],
  refunded: ["refunded", "#C080C0", "The invoice has been refunded. You will get your payment back to the source within 3-7 days."],
};

 export const STATUS = (quote, accountType) => quote ? [["Ready", "replied"], ["Ordered", "ordered"], ["In progress", "submitted"], ["Cancelled", "cancelled"]]
    : [['Draft', "created"], ['New', "new"], ['Assigend', "Assigend"], ['In Progress', "in-progress"],
    ["Quality Check", "support-review"], ["Revision", "revision"], ["Awaits Approval", "user-review"], accountType === AccountType.ADMIN.toLocaleLowerCase() ? ["Approved", "completed"] : ["Completed", "completed"],['Refunded', "refunded"], ["On Hold", "on-hold"],["Cancelled", "cancelled"]];

export const PAYMENT_STATUS = [["Paid", "paid"], ["Waiting Payment", "pay-later"], ["On Hold", "on-hold"], ["Overdue", "overdue"], ['Refunded', "refunded"],];

 export const SERVICES = [['Notarization', "notry"], ['Expedited Turnaround', "expedited"], ['Expedited+ Turnaround', "expedited+"], ['Mail Hard Copy', "hardCopy"]];

 export const ROLES = [['Support', AccountType.SUPPORT], ['Support Plus', "Support Plus"], ['Translator', AccountType.TRANSLATER]];

export const REF_LABELS_COLORS = { revised: "#F59E0B", reference: "#6C757D", notarized: "#12ABBF" };

export const selectColor = (role, selected = false) => {

  if(role === AccountType.OWNER){
    return "#f9bc59";
  }

  if(role === AccountType.SUPPORT || role === AccountType.TRANSLATER){
    return "#72ff75";
  }

  
  if(selected){
    return "#05a3b5";
  }

  return "#84d0d8";
}

export const selectStatusBackground = (status) => {

  if(status === AccountStatus.ACTIVE){
    return "#CEF3BE";
  }

  if(status === AccountStatus.PAUSED){
    return "#F0BFBE";
  }
}
export const selectCouponStatusBackground = (status) => {

  if(status === CouponStatus.ACTIVE){
    return "#CEF3BE";
  }

  if(status === CouponStatus.DEACTIVATED){
    return "#F0BFBE";
  }
}